/**
 * Fallback do `LandingRoute` enquanto `/me` resolve (#148). Substitui o `null`
 * que causava flash branco no cold start de `/` (caso comum: deslogado).
 * Fundo dark + esqueleto do nav e do hero pra evitar tanto o flash branco
 * quanto o flash inverso (landing → /painel) que renderizar a landing direto
 * causaria pro logado.
 *
 * Estático de propósito: o skeleton vive ~200ms, não justifica pulse infinito
 * (P17 — sem animação infinita em elemento não-essencial). `aria-hidden` porque
 * é placeholder visual, sem conteúdo que valha anunciar.
 */
export function LandingSkeleton() {
  return (
    <div data-testid="landing-skeleton" aria-hidden="true" className="min-h-screen bg-bg">
      {/* Nav */}
      <div className="border-b border-border">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 flex items-center gap-3 h-14">
          <div className="w-[22px] h-[22px] rounded-sm bg-bg-card" />
          <div className="h-3.5 w-24 rounded bg-bg-card" />
          <div className="flex-1" />
        </div>
      </div>

      {/* Hero (lado da copy) */}
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24">
        <div className="max-w-[520px] space-y-4">
          <div className="h-[26px] w-32 rounded-full bg-bg-card" />
          <div className="h-10 w-full rounded-md bg-bg-card" />
          <div className="h-10 w-3/4 rounded-md bg-bg-card" />
          <div className="h-5 w-2/3 rounded-md bg-bg-card mt-2" />
          <div className="h-11 w-40 rounded-md bg-bg-card mt-4" />
        </div>
      </div>
    </div>
  );
}
